import PropTypes from 'prop-types';

import PrivateRoute from '@Components/app-layout/PrivateRoute';
import AppRouter from '@Components/app-layout/Router';

import BuilderBlocksLayout from './views/blocks/Layout';
import PostsLayout from './views/post/Layout';
import RewardLayout from './views/rewards/Layout';
import SettingLayout from './views/setting/Layout';
import SnippetLayout from './views/snippets/Layout';
// import SettingLayout from './views/setting/Layout';

const propTypes = {
  types: PropTypes.array,
};

export default function CMSRoutes({ types }) {
  if (!types) return null

  const [redirect] = types

  return <AppRouter redirect={`/cms/${redirect}`}>
    <PrivateRoute path="/cms/settings" component={SettingLayout} />
    <PrivateRoute path="/cms/builder-blocks" component={BuilderBlocksLayout} />
    <PrivateRoute path="/cms/rewards" component={RewardLayout} />
    <PrivateRoute path="/cms/snippets" component={SnippetLayout} />
    {/* <PrivateRoute path="/cms/settings" component={SettingLayout} /> */}
    <PrivateRoute path={`/cms/:content_type(${types.join('|')})`} component={PostsLayout} />
  </AppRouter>
}

CMSRoutes.propTypes = propTypes
